// Necessary imports
import React from "react";
import i4 from "../components/Styles/assets/Graphics/daycare.webp";

import daycare7 from "../components/Styles/assets/Graphics/daycare7.webp";
import daycare2 from "../components/Styles/assets/Graphics/daycare2.webp";
import daycare6 from "../components/Styles/assets/Graphics/daycare6.webp";
import daycare4 from "../components/Styles/assets/Graphics/daycare4.webp";
import daycare5 from "../components/Styles/assets/Graphics/daycare5.webp";
import daycare8 from "../components/Styles/assets/Graphics/daycare8.webp";



import { StyledHCard, StyledClient } from "../components/Styles";
import Consultation from "../components/Consultation";
import ClientHorizontalCard from "../components/ClientHorizontalCard";

import { useTranslation } from "react-i18next";

const iconMapping = {
  card1: daycare4,
  card2: daycare5,
  card3: daycare2,
  card4: daycare6,
  card5: daycare7,
  card6: daycare8,
};

const Daycare = () => {
  const { t, i18n } = useTranslation();

  const cards = ["card1", "card2", "card3", "card4", "card5", "card6"];

  return (
    <StyledClient.Container>
      <StyledClient.Content>
        <StyledClient.ShapeTopLeft>
          <img src={i4} alt="Icon" />
        </StyledClient.ShapeTopLeft>

        <StyledClient.Title>
          {t("daycare.title")}
        </StyledClient.Title>

        <StyledClient.Description>
          {t("daycare.description")}
        </StyledClient.Description>
      </StyledClient.Content>

      <Consultation />

      <StyledClient.H3 lang={i18n.language}>{t("daycare.servicesTitle")}</StyledClient.H3>

      {cards.map((key, index) => (
        <ClientHorizontalCard
          key={index}
          title={t(`daycare.cards.${key}.title`)}
          subtitle={t(`daycare.cards.${key}.subtitle`)}
          visionPoints={t(`daycare.cards.${key}.visionPoints`, { returnObjects: true })}
          missionPoints={t(`daycare.cards.${key}.missionPoints`, { returnObjects: true })}
          icon={iconMapping[key]}
        />
      ))}

      <StyledHCard.Container />
      <Consultation />
    </StyledClient.Container>
  );
};

export default Daycare;